import { Box } from "@mui/material"
import { styled } from "@mui/material/styles"

const StyledBox = styled(Box)(({ noBorderBottom }) => {
  let newVar = {
    boxShadow: "0px 0px 15px 0px rgb(0 0 0 / 4%)",
    width: "100%",
  }
  if (noBorderBottom) {
    newVar = {
      ...newVar,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    }
  }
  return newVar
})

const PaperBox = (props) => {
  const { children, noBorderBottom, mt = 2, p = 3 } = props

  return (
    <StyledBox
      noBorderBottom={noBorderBottom}
      spacing={3}
      mt={mt}
      p={p}
      bgcolor="background.paper"
      borderRadius={2}
      {...props}
    >
      {children}
    </StyledBox>
  )
}

export default PaperBox
